export default __webpack_public_path__ + "static/cafe_36049-9d73fe28eef69cbe61c34f7c5f8eae42.png";